module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "EBook-Break",
    attrs: {
      "id": "_idParaDest-5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("And much of Madness, and more of Sin,"), _c('br'), _vm._v("And Horror the soul of the plot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("—Edgar Allan Poe")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_vm._v("New Orleans is a settlement of the dregs of the French bohème, in the truest sense of the word a French convict colony—and never, with the changes of time, has it belied its origin. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_c('span', {
    attrs: {
      "xml:lang": "de-DE"
    }
  }, [_vm._v("—Karl Marx, ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "de-DE"
    }
  }, [_vm._v("Die Presse")]), _c('span', {
    attrs: {
      "xml:lang": "de-DE"
    }
  }, [_vm._v(", May 20, 1862")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665c1afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook43514.vue
// module id = 75
// module chunks = 0